import EscapeFromTarkov01Thumb from './images/escape-from-tarkov-01-thumb.webp'
import EscapeFromTarkov01 from './images/escape-from-tarkov-01.webp'
import EscapeFromTarkov02Thumb from './images/escape-from-tarkov-02-thumb.webp'
import EscapeFromTarkov02 from './images/escape-from-tarkov-02.webp'
import EscapeFromTarkov03Thumb from './images/escape-from-tarkov-03-thumb.webp'
import EscapeFromTarkov03 from './images/escape-from-tarkov-03.webp'
import EscapeFromTarkov04Thumb from './images/escape-from-tarkov-04-thumb.webp'
import EscapeFromTarkov04 from './images/escape-from-tarkov-04.webp'
import EscapeFromTarkov05Thumb from './images/escape-from-tarkov-05-thumb.webp'
import EscapeFromTarkov05 from './images/escape-from-tarkov-05.webp'
import EscapeFromTarkov06Thumb from './images/escape-from-tarkov-06-thumb.webp'
import EscapeFromTarkov06 from './images/escape-from-tarkov-06.webp'
import EscapeFromTarkovBanner from './images/escape-from-tarkov-banner.webp'
import WorldOfSeaBattle01Thumb from './images/world-of-sea-battle-01-thumb.webp'
import WorldOfSeaBattle01 from './images/world-of-sea-battle-01.webp'
import WorldOfSeaBattle02Thumb from './images/world-of-sea-battle-02-thumb.webp'
import WorldOfSeaBattle02 from './images/world-of-sea-battle-02.webp'
import WorldOfSeaBattle03Thumb from './images/world-of-sea-battle-03-thumb.webp'
import WorldOfSeaBattle03 from './images/world-of-sea-battle-03.webp'
import WorldOfSeaBattle04Thumb from './images/world-of-sea-battle-04-thumb.webp'
import WorldOfSeaBattle04 from './images/world-of-sea-battle-04.webp'
import WorldOfSeaBattle05Thumb from './images/world-of-sea-battle-05-thumb.webp'
import WorldOfSeaBattle05 from './images/world-of-sea-battle-05.webp'
import WorldOfSeaBattle06Thumb from './images/world-of-sea-battle-06-thumb.webp'
import WorldOfSeaBattle06 from './images/world-of-sea-battle-06.webp'
import WorldOfSeaBattleBanner from './images/world-of-sea-battle-banner.webp'

export type SteamVerdict =
    | 'overwhelminglyPositive'
    | 'veryPositive'
    | 'positive'
    | 'mostlyPositive'
    | 'mixed'
    | 'mostlyNegative'
    | 'negative'
    | 'veryNegative'
    | 'overwhelminglyNegative'

export type SteamGameId = 'world-of-sea-battle' | 'escape-from-tarkov'

export type SteamScreenshot = {
    full: string
    thumb: string
}

type SteamReview = {
    verdict: SteamVerdict
    count: string
}

export type SteamGame = {
    id: SteamGameId
    name: string
    tags: string[]
    storeUrl: string
    banner: string
    screenshots: SteamScreenshot[]
    englishReviews: SteamReview
    recentReviews: SteamReview
}

export const STEAM_GAMES: SteamGame[] = [
    {
        id: 'world-of-sea-battle',
        name: 'World of Sea Battle',
        tags: ['MMO', 'Online PvP', 'English +10'],
        storeUrl: 'https://store.steampowered.com/app/2948190/World_of_Sea_Battle/',
        banner: WorldOfSeaBattleBanner,
        screenshots: [
            { full: WorldOfSeaBattle01, thumb: WorldOfSeaBattle01Thumb },
            { full: WorldOfSeaBattle02, thumb: WorldOfSeaBattle02Thumb },
            { full: WorldOfSeaBattle03, thumb: WorldOfSeaBattle03Thumb },
            { full: WorldOfSeaBattle04, thumb: WorldOfSeaBattle04Thumb },
            { full: WorldOfSeaBattle05, thumb: WorldOfSeaBattle05Thumb },
            { full: WorldOfSeaBattle06, thumb: WorldOfSeaBattle06Thumb },
        ],
        englishReviews: { verdict: 'mostlyPositive', count: '3,217' },
        recentReviews: { verdict: 'mostlyPositive', count: '526' },
    },
    {
        id: 'escape-from-tarkov',
        name: 'Escape from Tarkov',
        tags: ['MMO', 'Online PvP', 'English +20'],
        storeUrl: 'https://store.steampowered.com/app/3932890/Escape_from_Tarkov/',
        banner: EscapeFromTarkovBanner,
        screenshots: [
            { full: EscapeFromTarkov01, thumb: EscapeFromTarkov01Thumb },
            { full: EscapeFromTarkov02, thumb: EscapeFromTarkov02Thumb },
            { full: EscapeFromTarkov03, thumb: EscapeFromTarkov03Thumb },
            { full: EscapeFromTarkov04, thumb: EscapeFromTarkov04Thumb },
            { full: EscapeFromTarkov05, thumb: EscapeFromTarkov05Thumb },
            { full: EscapeFromTarkov06, thumb: EscapeFromTarkov06Thumb },
        ],
        englishReviews: { verdict: 'mixed', count: '11,885' },
        recentReviews: { verdict: 'mixed', count: '3,511' },
    },
]
